module.exports = {
  format: function(timestamp) {
    return moment(timestamp).format('MMM Do, YYYY');
  }
};
